import { combineReducers } from 'redux';
import account from './account';
import organizations from './organizations';
import events from './events';
import users from './users';
import admins from './admins';
import staticData from './staticData';
import reports from './reports';
import categories from './categories';
import articles from './articles';
import adminAccess from './adminAccess';

const rootReducer = combineReducers({
  account,
  organizations,
  events,
  users,
  admins,
  staticData,
  reports,
  categories,
  articles,
  adminAccess,
});

export default rootReducer;
